/* @flow */

import * as React from 'react';
import Helmet from 'react-helmet';
import { connect } from 'react-redux';
import { get } from 'lodash/fp';
import styled from '@emotion/styled';
import Clickable from 'app/components/commons/Clickable';
import t from 'app/utils/translate';
import { toggleCommunicationPreference } from 'app/actions/userActions';
import Icon from '../../components/commons/Icon';

type Props = {
  onTogglePreference: (data: Object) => void,
  smsOptedOut: boolean
};

const Section = styled.div(({ theme }) => ({
  color: theme.color.black,
  borderRadius: theme.spacing.large
}));

const Content = styled.div({
  '& > :nth-of-type(odd)': {
    backgroundColor: '#eaedf4'
  },
  '& > :nth-of-type(even)': {
    backgroundColor: '#f0f1f6'
  }
});

const Row = styled.div(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  padding: theme.spacing.small,
  fontSize: theme.fontSize.medium
}));

const Title = styled.div(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  fontSize: theme.fontSize.large
}));

const Header = styled(Row)(({ theme }) => ({
  width: '100%',
  justifyContent: 'space-between',
  padding: `0px ${theme.spacing.small}px`,
  backgroundColor: theme.color.panel,
  color: theme.color.panelAccent
}));

const StyledIcon = styled(Icon)(({ theme }) => ({
  marginRight: theme.spacing.small
}));

const IconToggleOn = styled(props => <Icon type="icon-toggle-on" {...props} />)(({ theme }) => ({
  color: theme.color.success
}));

const IconToggleOff = styled(props => <Icon type="icon-toggle-on" {...props} />)({
  transform: 'rotate(180deg)',
  color: 'grey'
});

function AccountSettings({ onTogglePreference, smsOptedOut }: Props) {
  const [isSmsOptedOut, setIsSmsOptedOut] = React.useState(smsOptedOut);
  const handleTogglePreference = () => {
    setIsSmsOptedOut(!isSmsOptedOut);
    onTogglePreference({ sms_opted_out: !smsOptedOut });
  };

  return (
    <div className="page-container">
      <Helmet title="Settings" />
      <Section>
        <Header>
          <Title>
            <StyledIcon type="icon-comment-dots" size={30} />
            <h2>SMS Notifications</h2>
          </Title>
          <Clickable onClick={handleTogglePreference}>
            {isSmsOptedOut ? <IconToggleOff size={45} /> : <IconToggleOn size={45} />}
          </Clickable>
        </Header>
        <Content>
          <Row>
            <StyledIcon type="icon-check-circle" size={20} />
            <span>{t('Challenge')} Reminders</span>
          </Row>
          <Row>
            <StyledIcon type="icon-check-circle" size={20} />
            <span>Bonus Offers and Promotions</span>
          </Row>
          <Row>
            <StyledIcon type="icon-check-circle" size={20} />
            <span>News and Updates</span>
          </Row>
          <Row>
            <StyledIcon type="icon-check-circle" size={20} />
            <span>Affiliate Promotions</span>
          </Row>
        </Content>
      </Section>
    </div>
  );
}

function mapStateToProps({ user }) {
  return {
    smsOptedOut: !!get('currentUser.sms_opted_out', user)
  };
}

const actions = {
  onTogglePreference: toggleCommunicationPreference
};

export default connect(
  mapStateToProps,
  actions
)(AccountSettings);
